// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__39OeU","errors":"Errors_errors__2lJCY"};